module.exports = __webpack_public_path__ + "static/media/digital.9ddfd46a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/digital.svg
// module id = 269
// module chunks = 0